import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20Naruto%20anime%20fan%20art%20collage%20with%20warm%20orange%20and%20crimson%20color%20tones%2C%20Japanese%20manga%20style%20illustration%2C%20dynamic%20ninja%20poses%2C%20traditional%20Japanese%20aesthetic%20elements%2C%20soft%20gradient%20background%20with%20ink%20wash%20texture&width=1800&height=800&seq=hero-naruto-doujin&orientation=landscape"
          alt="火影同人创作文化"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <span className="inline-block text-xs md:text-sm font-medium text-primary-300 bg-primary-500/20 backdrop-blur-sm px-4 py-1.5 rounded-full mb-6 tracking-wider">
          火影粉丝与同人爱好者的终极参考资料
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
          火影同人创作
          <br />
          <span className="text-primary-300">完全指南</span>
        </h1>
        <p className="mt-6 text-sm md:text-base text-white/80 max-w-2xl mx-auto leading-relaxed">
          深度解析火影同人文化的起源、创作风格与收藏价值，带你了解火影忍者周边同人圈的独特生态，
          从角色设定到画风流派一网打尽，是火影粉丝与同人爱好者不可错过的参考资料。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/character-analysis"
            className="whitespace-nowrap bg-primary-500 text-white px-8 py-3 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
          >
            探索角色设定
          </Link>
          <Link
            to="/category/culture-origins"
            className="whitespace-nowrap bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-3 rounded-full font-medium text-sm hover:bg-white/20 transition-colors cursor-pointer"
          >
            了解同人文化
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1">
          <div className="w-1.5 h-1.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}